// Last click, focus or key (by data-testid, which survives minification) for error logs.
// Typed characters are never recorded.
let lastInteraction = "none recorded";

const describeKey = (event: Event): string => {
    if (!(event instanceof KeyboardEvent)) {
        return "";
    }
    return event.key.length === 1 ? " (character)" : ` ${event.key}`;
};

export const describeInteraction = (event: Event): string => {
    const target = event.target instanceof Element ? event.target : null;
    const targetName =
        target?.closest("[data-testid]")?.getAttribute("data-testid") ?? target?.tagName ?? "page";
    return `${event.type}${describeKey(event)} on ${targetName}`;
};

export const startInteractionTracking = (): void => {
    ["click", "focusin", "keydown"].forEach((type) =>
        window.addEventListener(
            type,
            (event) => (lastInteraction = describeInteraction(event)),
            true
        )
    );
};

export const getLastInteraction = (): string => lastInteraction;
